<div class="container-fluid institution-page">

  <div class="institution-card">

    <!-- ====================================================== -->
    <!-- HEADER -->
    <!-- ====================================================== -->

    <div class="institution-header">

      <div class="institution-header-info">

        <div class="institution-header-icon">
          <i class="fa-solid fa-building"></i>
        </div>

        <div>
          <h5 class="institution-title">
            Configuración institucional
          </h5>

          <p class="institution-description">
            Personaliza la identidad visual de la institución.
          </p>
        </div>

      </div>


      <!-- INFORMACIÓN -->

      <div class="institution-meta" *ngIf="settings">

        <div class="meta-item">
          <span class="meta-label">ID</span>
          <span class="meta-value">
            {{ settings?.id }}
          </span>
        </div>

        <div class="meta-divider"></div>

        <div class="meta-item">
          <span class="meta-label">
            Última actualización
          </span>

          <span class="meta-value">
            {{ settings?.updatedAt | date : 'short' }}
          </span>
        </div>

      </div>

    </div>


    <!-- ====================================================== -->
    <!-- BODY -->
    <!-- ====================================================== -->

    <div class="institution-body">

      <form
        [formGroup]="form"
        (ngSubmit)="onSubmit()"
        class="institution-form">


        <!-- ================================================== -->
        <!-- INFORMACIÓN GENERAL -->
        <!-- ================================================== -->

        <div class="form-section">

          <div class="section-header">

            <div class="section-icon">
              <i class="fa-solid fa-building-columns"></i>
            </div>

            <div>
              <h6 class="section-title">
                Información general
              </h6>

              <p class="section-description">
                Define el nombre que identificará a la institución.
              </p>
            </div>

          </div>


          <!-- NOMBRE -->

          <div class="field-group">

            <label
              for="name"
              class="form-label">

              Nombre de la institución

              <span class="required-mark">*</span>

            </label>


            <div class="input-modern">

              <i class="fa-solid fa-building"></i>

              <input
                id="name"
                type="text"
                class="form-control"
                formControlName="name"
                placeholder="Ej. Firma365"
                [class.is-invalid]="
                  form.get('name')?.touched &&
                  form.get('name')?.hasError('required')
                " />

            </div>


            <div
              class="field-error"
              *ngIf="
                form.get('name')?.touched &&
                form.get('name')?.hasError('required')
              ">

              <i class="fa-solid fa-circle-exclamation"></i>

              <span>
                El nombre es requerido.
              </span>

            </div>

          </div>

        </div>


        <!-- ================================================== -->
        <!-- IDENTIDAD VISUAL -->
        <!-- ================================================== -->

        <div class="form-section">

          <div class="section-header">

            <div class="section-icon">
              <i class="fa-solid fa-palette"></i>
            </div>

            <div>
              <h6 class="section-title">
                Identidad visual
              </h6>

              <p class="section-description">
                Configura el color principal y el logo institucional.
              </p>
            </div>

          </div>


          <!-- ================================================= -->
          <!-- COLOR PRIMARIO -->
          <!-- ================================================= -->

          <div class="field-group">

            <label
              for="primaryColor"
              class="form-label">

              Color primario

            </label>


            <div class="color-selector">

              <div class="color-picker-wrapper">

                <input
                  id="primaryColor"
                  type="color"
                  class="color-picker"
                  formControlName="primaryColor" />

              </div>


              <div class="color-info">

                <span class="color-label">
                  Color seleccionado
                </span>

                <div class="color-value">

                  <span
                    class="color-preview"
                    [ngStyle]="{
                      'background-color': form.value.primaryColor
                    }">
                  </span>

                  <span class="color-code">
                    {{ form.value.primaryColor }}
                  </span>

                </div>

              </div>

            </div>

          </div>


          <!-- ================================================= -->
          <!-- LOGO -->
          <!-- ================================================= -->

          <div class="field-group mb-0">

            <label
              for="logo"
              class="form-label">

              Logo institucional

            </label>


            <div
              class="logo-upload"
              [class.is-disabled]="loadingLogo">

              <div class="logo-upload-icon">

                <i
                  class="fa-solid"
                  [ngClass]="loadingLogo
                    ? 'fa-spinner fa-spin'
                    : 'fa-cloud-arrow-up'">
                </i>

              </div>


              <div class="logo-upload-content">

                <span class="logo-upload-title">
                  {{ loadingLogo
                    ? 'Procesando imagen...'
                    : 'Seleccionar logo'
                  }}
                </span>

                <span class="logo-upload-description">
                  PNG, JPG, JPEG u otro formato de imagen. Máximo 2 MB.
                </span>

              </div>


              <label
                for="logo"
                class="btn-select-file"
                [class.disabled]="loadingLogo">

                <i class="fa-solid fa-image"></i>

                Seleccionar

              </label>


              <input
                id="logo"
                type="file"
                accept="image/*"
                (change)="onLogoSelected($event)"
                [disabled]="loadingLogo"
                class="file-input" />

            </div>


            <!-- =============================================== -->
            <!-- PREVIEW LOGO -->
            <!-- =============================================== -->

            <div
              class="logo-preview"
              *ngIf="previewLogoUrl">

              <div class="logo-preview-header">

                <div>

                  <span class="logo-preview-title">
                    Vista previa
                  </span>

                  <span class="logo-preview-description">
                    Logo institucional actual
                  </span>

                </div>


                <div class="preview-status">

                  <i class="fa-solid fa-circle-check"></i>

                  Disponible

                </div>

              </div>


              <div class="logo-preview-area">

                <img
                  [src]="previewLogoUrl"
                  alt="Logo institucional"
                  class="logo-preview-image" />

              </div>

            </div>

          </div>

        </div>


        <!-- ================================================== -->
        <!-- ACCIONES -->
        <!-- ================================================== -->

        <div class="form-actions">

          <button
            type="submit"
            class="btn btn-primary btn-save"
            [disabled]="loading || form.invalid">


            <ng-container *ngIf="!loading">

              <i class="fa-solid fa-floppy-disk"></i>

              <span>
                Guardar cambios
              </span>

            </ng-container>


            <ng-container *ngIf="loading">

              <i class="fa-solid fa-spinner fa-spin"></i>

              <span>
                Guardando...
              </span>

            </ng-container>

          </button>

        </div>

      </form>

    </div>

  </div>

</div>